// src/hooks/productTypes/useCreateProductType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createProductType } from "../../api/apiProductTypes";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateProductType = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createProductTypes, isPending } = useMutation({
        mutationFn: createProductType,
        onSuccess: (res) => {
            const message = res?.message || "Product type created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
            navigate("/product-types");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create product type");
        },
    });

    return { createProductTypes, isPending };
};

export default useCreateProductType;